import { createAction, props } from '@ngrx/store';
import { ConfigurationHeaderStyle } from '../reducers/set-header.reducer';

export const getConf   = createAction(
  '[UI Header Style] Set Header',
  props<{ data: ConfigurationHeaderStyle }>()
);

export const getConfCustom   = createAction(
  '[UI Header Style] Set Header Custom',
  props<{ dataCustom: ConfigurationHeaderStyle }>()
);